/* eslint-disable no-unused-vars */
import React, { Fragment, useEffect, useState } from 'react'
import TextDescription from './elements/TextDescription'
import {
  elementTypes,
  getFirstKeyFromObject,
  requiredAuthorizationOptionsObj
} from '../../utils/formBuilder'
import CheckListItem from './elements/CheckListItem'
import DropDownSelection from './elements/DropDownSelection'
import MultiButtonSelection from './elements/MultiButtonSelection'
import PhotosElement from './elements/PhotosElement'
import SignatureElement from './elements/SignatureElement'
import { getNested } from '../../utils/mobilePreview'
import LineItems from './elements/LineItems/LineItems'
import DateTimeElement from './elements/DateTimeElement'
import AttachmentsElement from './elements/AttachmentsElement'
import Materials from './elements/Materials/Materials'
import AuthorizationField from './elements/AuthorizationField'
import { Box, Typography } from '@mui/material'
import ElementContainer from './ElementContainer'
import { eaServicesComponentStyles } from '../../styles/classes/MobilePreviewClasses'
import { useTranslation } from 'react-i18next'
import ServiceChecklist from './elements/ServiceChecklist'

const EqServicesComponentV2 = ({
  element,
  sectionId,
  onChangeDataValue,
  dataObject,
  isPreviewMode,
  onPreviewModeSwitch,
  extraData,
  totalAmountDueValue
}) => {
  const { t } = useTranslation()
  const { classes } = eaServicesComponentStyles()
  const elementId = getFirstKeyFromObject(element)
  const elementData = element[elementId]
  const elementType = elementData?.type
  let elementHelpfuHint = elementData?.helpful_hint
  const value = getNested(dataObject, sectionId, elementId)
  let isMandatory = elementData?.required
  const disabled = isPreviewMode
  if (isPreviewMode) {
    isMandatory = false
    elementHelpfuHint = ''
  }

  let renderAuthElement = false
  if (
    sectionId === extraData.lastItemWithTotalAmountDue.sectionKey &&
    elementId === extraData.lastItemWithTotalAmountDue.questionKey
  ) {
    renderAuthElement = true
  }

  const ElementOuterContainer = ({ children }) => {
    return (
      <div style={{ marginBottom: isPreviewMode ? '5px' : '20px' }}>
        {children}
      </div>
    )
  }

  const changeValueHandler = inputValue => {
    onChangeDataValue(inputValue, sectionId, elementId)
  }

  function totalAmountDue () {
    return (
      <ElementOuterContainer>
        <ElementContainer applyShadow={true}>
          <Typography className={classes.totalAmountTitle}>
            {t('mobile_preview.authorization_field.total_amount_due')}
          </Typography>
          <Typography className={classes.totalAmountValue}>
            ${totalAmountDueValue}
          </Typography>
        </ElementContainer>
      </ElementOuterContainer>
    )
  }
  switch (elementType) {
    case elementTypes.SIGNATURE:
      return (
        <ElementOuterContainer>
          <SignatureElement
            disabled={disabled}
            isPreviewMode={isPreviewMode}
            isMandatory={isMandatory}
            answer={value}
            onChangeValue={changeValueHandler}
            helpfulHint={elementHelpfuHint}
            title={elementData.title}
          />
        </ElementOuterContainer>
      )
    case elementTypes.PHOTOS:
      return (
        <ElementOuterContainer>
          <PhotosElement
            disabled={disabled}
            isPreviewMode={isPreviewMode}
            isMandatory={isMandatory}
            photos={elementData.photos}
            answer={value}
            onChangeValue={changeValueHandler}
            helpfulHint={elementHelpfuHint}
            title={elementData.title}
          />
        </ElementOuterContainer>
      )
    case elementTypes.ATTACHMENTS:
      return (
        <ElementOuterContainer>
          <AttachmentsElement
            disabled={disabled}
            isPreviewMode={isPreviewMode}
            isMandatory={isMandatory}
            attachments={elementData.attachments}
            answer={value}
            onChangeValue={changeValueHandler}
            helpfulHint={elementHelpfuHint}
            title={elementData.title}
          />
        </ElementOuterContainer>
      )
    case elementTypes.SERVICE_CHECKLIST:
      return (
        <ElementOuterContainer>
          <ServiceChecklist
            disabled={disabled}
            isPreviewMode={isPreviewMode}
            isMandatory={isMandatory}
            attachments={elementData.attachments}
            answer={value}
            onChangeValue={changeValueHandler}
            helpfulHint={elementHelpfuHint}
            servicesSettings={elementData}
          />
        </ElementOuterContainer>
      )
    case elementTypes.MULTI_BUTTON_SELECTION:
      return (
        <ElementOuterContainer>
          <MultiButtonSelection
            disabled={disabled}
            isPreviewMode={isPreviewMode}
            isMandatory={isMandatory}
            answer={value}
            onChangeValue={changeValueHandler}
            buttonsList={elementData.buttons}
            selectionType={elementData?.number_of_selections}
            helpfulHint={elementHelpfuHint}
            title={elementData.title}
          />
        </ElementOuterContainer>
      )
    case elementTypes.DROPDOWN_SELECTION:
      return (
        <ElementOuterContainer>
          <DropDownSelection
            disabled={disabled}
            isPreviewMode={isPreviewMode}
            isMandatory={isMandatory}
            answer={value}
            onChangeValue={changeValueHandler}
            itemOptions={elementData.options}
            multiCheck={elementData.selection_type !== 'single_selection'}
            helpfulHint={elementHelpfuHint}
            title={elementData.title}
          />
        </ElementOuterContainer>
      )
    case elementTypes.CHECKLIST_ITEM:
      return (
        <CheckListItem
          disabled={disabled}
          isPreviewMode={isPreviewMode}
          isMandatory={isMandatory}
          answer={value}
          onChangeValue={changeValueHandler}
          mode={elementData.selection_option}
          helpfulHint={elementHelpfuHint}
          title={elementData.title}
          placeholder={elementData.empty_state_message}
        />
      )
    case elementTypes.TEXT_DESCRIPTION:
      if (elementData.input_field_type === 'date_time') {
        return (
          <ElementOuterContainer>
            <DateTimeElement
              disabled={disabled}
              isPreviewMode={isPreviewMode}
              isMandatory={isMandatory}
              answer={value}
              onChangeValue={changeValueHandler}
              helpfulHint={elementHelpfuHint}
              inputFieldType={elementData?.input_field_type}
              title={elementData.title}
              placeholder={elementData.empty_state_message}
            />
          </ElementOuterContainer>
        )
      }

      return (
        <ElementOuterContainer>
          <TextDescription
            disabled={disabled}
            isPreviewMode={isPreviewMode}
            decimals={2}
            isMandatory={isMandatory}
            answer={value}
            onChangeValue={changeValueHandler}
            helpfulHint={elementHelpfuHint}
            inputFieldType={elementData?.input_field_type}
            title={elementData.title}
            placeholder={elementData.empty_state_message}
          />
        </ElementOuterContainer>
      )
    case elementTypes.LINE_ITEMS:
      return (
        <Fragment>
          <ElementOuterContainer>
            <LineItems
              disabled={disabled}
              isPreviewMode={isPreviewMode}
              question={elementData}
              helpfulHint={elementHelpfuHint}
              isMandatory={isMandatory}
              onChangeValue={changeValueHandler}
              lineItemsList={value}
            />
          </ElementOuterContainer>
          {renderAuthElement && isPreviewMode && totalAmountDue()}
        </Fragment>
      )
    case elementTypes.MATERIAL_PARTS:
      return (
        <Fragment>
          <ElementOuterContainer>
            <Materials
              disabled={disabled}
              isPreviewMode={isPreviewMode}
              question={elementData}
              helpfulHint={elementHelpfuHint}
              isMandatory={isMandatory}
              onChangeValue={changeValueHandler}
              lineItemsList={value}
            />
          </ElementOuterContainer>
          {renderAuthElement && isPreviewMode && totalAmountDue()}
        </Fragment>
      )
    case elementTypes.AUTHORIZATION_FIELD:
      return (
        <ElementOuterContainer>
          <AuthorizationField
            disabled={false}
            isPreviewMode={isPreviewMode}
            question={elementData}
            helpfulHint={elementHelpfuHint}
            required={elementData?.required}
            onChangeValue={changeValueHandler}
            answer={value}
            onPreviewModeSwitch={onPreviewModeSwitch}
          />
        </ElementOuterContainer>
      )
    default:
      return null
  }
}

const MemoizedEqServicesComponentV2 = React.memo(EqServicesComponentV2)

export default MemoizedEqServicesComponentV2
